<template>
  <v-dialog
    :value="value"
    max-width="440"
    @input="$emit('input', $event)"
  >
    <v-card class="trocar-empresa-card">
      <v-card-title class="pb-1 pt-4 px-4 d-flex align-center">
        <v-icon color="#0052a0" class="mr-2">mdi-swap-horizontal</v-icon>
        <span class="title text-h6 font-weight-bold" style="color: #003668"
          >Trocar credor</span
        >
        <v-spacer />
        <v-btn icon small aria-label="Fechar" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-4 pb-2">
        <p class="body-2 mb-3" style="color: #5c6370">
          Escolha o credor para continuar. Você permanece na mesma tela.
        </p>
        <v-select
          v-model="selectedId"
          :items="empresas"
          item-value="id"
          label="Credor"
          outlined
          dense
          hide-details="auto"
          :disabled="loading"
          color="#0052a0"
        >
          <template slot="item" slot-scope="data">
            <v-icon small color="#0052a0" class="mr-1">mdi-domain</v-icon>
            <span class="text-truncate"
              >{{ data.item.id }} — {{ data.item.name }} —
              {{ data.item.cpf_cnpj }}</span
            >
          </template>
          <template slot="selection" slot-scope="data">
            <v-icon small color="#0052a0" class="mr-1">mdi-domain</v-icon>
            <span class="text-truncate"
              >{{ data.item.id }} — {{ data.item.name }}</span
            >
          </template>
        </v-select>
      </v-card-text>
      <v-card-actions class="px-4 pb-4 pt-0">
        <v-spacer />
        <v-btn text color="#666" @click="close" :disabled="loading"
          >Cancelar</v-btn
        >
        <v-btn
          color="#0052a0"
          dark
          depressed
          :loading="loading"
          :disabled="!canConfirm"
          @click="confirmar"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TrocarEmpresaDialog",
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({
    selectedId: null,
    loading: false,
  }),
  computed: {
    empresas() {
      const u = this.$store.state.auth.user;
      return (u && u.empresas) || [];
    },
    domain() {
      const u = this.$store.state.auth.user;
      return u && u.domain ? u.domain : null;
    },
    canConfirm() {
      if (!this.selectedId) return false;
      if (!this.domain || !this.domain.id) return true;
      return this.selectedId !== this.domain.id;
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.syncSelection();
      }
    },
  },
  methods: {
    ...mapActions("auth", ["ActionSelectDomain"]),
    syncSelection() {
      if (this.domain && this.domain.id != null) {
        this.selectedId = this.domain.id;
      } else if (this.empresas.length) {
        this.selectedId = this.empresas[0].id;
      } else {
        this.selectedId = null;
      }
    },
    close() {
      this.$emit("input", false);
    },
    async confirmar() {
      if (!this.canConfirm) {
        this.close();
        return;
      }
      try {
        this.loading = true;
        await this.ActionSelectDomain(this.selectedId);
        this.$emit("empresa-alterada");
        this.close();
      } catch (e) {
        const msg =
          (e && e.body && e.body.message) ||
          (e && e.data && e.data.message) ||
          "Não foi possível trocar de empresa.";
        alert(msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.trocar-empresa-card {
  border-radius: 12px !important;
}
</style>
